/* import __COLOCATED_TEMPLATE__ from './contact-complete.hbs'; */
import Component from '@glimmer/component';
import styles from './contact-complete.module.scss';

export default class SharedContactComplete extends Component {
  styles = styles;
}
